import Vue from 'vue'

// As a plugin
import VueMask from 'v-mask'
Vue.use(VueMask, {
  placeholders: {
    V: /[a-zA-Z \-&]/, // cyrillic letter as a placeholder
    E: /[0-9a-zA-Z.\-_@]/,
  }
})
